<template>
  <div class="error-404" />
</template>

<script>
import config from '@/config'

export default {
  name: 'error-404',
  created() {
    window.location.replace(config.owqloWebsiteUrl)
  }
}
</script>
